export default __webpack_public_path__ + "5a63050d6c2ac70bd0bb6e1be5bbe552.svg";